import { Button, Grid, Typography } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import { lang } from "i18nLang";
import { Details, GridDetails, Message, Title } from "./style";

const ErrorDetails = ({ details }) => {
  let detailsArray: any = [];
  if (details) detailsArray = typeof details === "string" ? [details] : details;

  return (
    <Details>
      {detailsArray.map((detail) => (
        <Typography
          color="error"
          variant="caption"
          style={{ display: "block" }}
        >
          {detail}
        </Typography>
      ))}
    </Details>
  );
};

interface IPropsError {
  /** Função que será executada ao fechar o Layer de Erro */
  onClose: any;
  /** Título do erro */
  title: string;
  /** Mensagem de erro */
  message: string;
  /** Detalhes do Erro */
  details?: string | string[];
}

/** Etapa na qual será exido o(s) error(s) da importação do contrato.
 * @category Components
 */
const ErrorLayer = (props: IPropsError) => (
  <Grid
    container
    direction="column"
    justifyContent="center"
    alignItems="center"
  >
    <Grid item>
      <CancelIcon color="error" style={{ fontSize: "5rem" }} />
    </Grid>
    <GridDetails
      item
      style={{
        display: props.details ? "" : "none",
      }}
    >
      <Title>{props.title}</Title>
      <ErrorDetails details={props.details} />
    </GridDetails>
    <Grid item xs={8}>
      <Message variant="caption">{props.message}</Message>
    </Grid>
    <Grid item style={{ marginTop: "1.25rem" }}>
      <Button color="primary" onClick={props.onClose}>
        {lang("tryAgain")}
      </Button>
    </Grid>
  </Grid>
);

export default ErrorLayer;
